<template>
  <div class="shop-cart" :class="{ 'shop-cart--expanded': expanded }" :style="{ '--cw': cartWidth + 'px' }">
    <!-- HEADER -->
    <div class="cart-hdr">
      <v-tooltip bottom max-width="240" color="white" content-class="vpc-tooltip">
        <template v-slot:activator="{ on }">
          <button class="cart-expand-btn" v-on="on" @click="$emit('expand')">
            <v-icon size="20" color="#00BCD4">{{ expanded ? 'mdi-chevron-right' : 'mdi-chevron-left' }}</v-icon>
          </button>
        </template>
        <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;line-height:1.5;">
          {{ expanded ? 'Smanji košaricu — vrati na standardni prikaz s artiklima i kategorijama.' : 'Proširi košaricu — prikaži detaljnu tablicu stavki s mogućnošću uređivanja cijena, popusta i KPD šifri.' }}
        </span>
      </v-tooltip>
      <span class="cart-title">
        Košarica
        <v-tooltip v-if="cart.length" bottom max-width="200" color="white" content-class="vpc-tooltip">
          <template v-slot:activator="{ on }">
            <span class="cart-count" v-on="on">{{ cart.length }}</span>
          </template>
          <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;line-height:1.5;">
            {{ cart.length }} {{ cart.length === 1 ? 'artikl u košarici' : cart.length < 5 ? 'artikla u košarici' : 'artikala u košarici' }}
          </span>
        </v-tooltip>
        <v-tooltip v-if="wholesaleView" bottom max-width="260" color="white" content-class="vpc-tooltip">
          <template v-slot:activator="{ on }">
            <span class="cart-vpc-badge" v-on="on">VPC</span>
          </template>
          <span style="font-size:12px;color:#1e293b;background:#fff;padding:8px 10px;border-radius:8px;display:block;line-height:1.5;">Aktivan je veleprodajni način rada — prikazuju se cijene bez PDV-a (VPC).<br>Za promjenu klikni ⋮ → Aktiviraj Maloprodaju.</span>
        </v-tooltip>
      </span>
      <!-- Dodaj artikl u headeru — poravnat na desni rub middle dijela -->
      <button v-if="expanded" class="btn-add-item-hdr" @click="$emit('open-write-in')">
        <v-icon size="14" class="mr-1">mdi-plus</v-icon>
        Dodaj stavku na račun
      </button>
      <v-menu offset-y left>
        <template v-slot:activator="{ on }">
          <button class="cart-menu-btn" v-on="on" title="Više opcija">⋮</button>
        </template>
        <v-list dense style="border-radius: 10px; overflow: hidden; min-width: 190px;">
          <v-list-item @click="$emit('open-close-balance')">
            <v-icon size="16" color="#00BCD4" class="mr-2">mdi-calculator-variant-outline</v-icon>
            <v-list-item-title style="font-size:13px;font-weight:700;color:#00BCD4;">Zaključak blagajne</v-list-item-title>
          </v-list-item>
          <v-divider />
          <v-list-item @click="$emit('open-note-modal')">
            <v-icon size="16" color="#00BCD4" class="mr-2">mdi-note-text-outline</v-icon>
            <v-list-item-title style="font-size:13px;">Napomena</v-list-item-title>
          </v-list-item>
          <!-- Veleprodaja toggle — samo za VP/ALL -->
          <v-list-item v-if="showWholesaleToggle" @click="$emit('toggle-wholesale')">
            <v-icon size="16" :color="wholesaleView ? '#94A3B8' : '#00BCD4'" class="mr-2">
              {{ wholesaleView ? 'mdi-account-outline' : 'mdi-domain' }}
            </v-icon>
            <v-list-item-title style="font-size:13px;">
              {{ wholesaleView ? 'Aktiviraj Maloprodaju (MPC)' : 'Aktiviraj Veleprodaju (VPC)' }}
            </v-list-item-title>
          </v-list-item>
          <v-divider v-if="showWholesaleToggle" />
          <v-list-item @click="$emit('clear-cart')">
            <v-icon size="16" color="#E53935" class="mr-2">mdi-delete-outline</v-icon>
            <v-list-item-title style="font-size:13px;color:#E53935;">Obriši sve stavke</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </div>

    <div class="cart-body">

      <!-- LIJEVO: vidljivo samo u expanded modu (artikli + kupac + opcije) -->
      <div class="cart-left">
        <!-- Centriran sadržaj max 800px -->
        <div class="cart-left-inner">
        <!-- Expanded tablica — compact stil kao CrudTemplate -->
        <div v-show="showExpandedContent" class="exp-table-wrap">
          <div v-if="cart.length === 0" class="cart-empty" style="padding-top:48px;">
            <v-icon size="36" color="#E0E6ED">mdi-cart-outline</v-icon>
            <span>Košarica je prazna</span>
          </div>
          <table v-else class="exp-table">
            <thead>
              <tr>
                <th class="col-num">#</th>
                <th class="col-name">Naziv artikla</th>
                <th class="col-qty">Kol.</th>
                <th class="col-price">MPC (€)</th>
                <th v-if="showVpc" class="col-price">VPC (€)</th>
                <th class="col-disc">Popust % / €</th>
                <th class="col-tax">PDV</th>
                <th class="col-total">Iznos</th>
                <th v-if="eracunActive" class="col-kpd">KPD šifra</th>
                <th class="col-del"></th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, idx) in cart"
                :key="`left-${item.id}-${idx}`"
                class="exp-row"
              >
                <td class="col-num">{{ idx + 1 }}</td>
                <td class="col-name">
                  <div class="exp-name">{{ item.name }}</div>
                  <div v-if="item.code" class="exp-code">{{ item.code }}</div>
                </td>
                <!-- Količina -->
                <td class="col-qty">
                  <v-text-field
                    :value="parseFloat(item.quantity).toFixed(2)"
                    type="number" min="0.001" step="0.001"
                    outlined dense hide-details
                    class="exp-input"
                    @focus="$event.target.select()"
                    @blur="v => $emit('update-item-field', idx, 'quantity', parseFloat(v.target.value) || 1)"
                  />
                </td>
                <!-- Cijena -->
                <td class="col-price">
                  <v-text-field
                    :value="((item.unitPrice || item.price) / 100).toFixed(2)"
                    type="number" min="0" step="0.01"
                    outlined dense hide-details
                    class="exp-input"
                    @focus="$event.target.select()"
                    @blur="v => $emit('update-item-field', idx, 'unitPrice', Math.round(parseFloat(v.target.value) * 100) || 0)"
                  />
                </td>
                <!-- VPC — samo za T, editabilno -->
                <td v-if="showVpc" class="col-price">
                  <v-text-field
                    :value="(vpcUnitPrice(item) / 100).toFixed(2)"
                    type="number" min="0" step="0.01"
                    outlined dense hide-details
                    class="exp-input"
                    @focus="$event.target.select()"
                    @blur="v => $emit('update-item-field', idx, 'unitPrice', Math.round(parseFloat(v.target.value) * 100 * (1 + (item.tax && item.tax.rate != null ? item.tax.rate : 0))))"
                  />
                </td>
                <!-- Popust % i iznos -->
                <td class="col-disc">
                  <div class="disc-pair">
                    <v-text-field
                      :value="discPct(item)"
                      type="number" min="0" max="100" step="0.01"
                      outlined dense hide-details
                      class="exp-input disc-pct"
                      suffix="%"
                      @focus="$event.target.select()"
                      @blur="v => onExpDiscPctBlur(idx, item, v.target.value)"
                    />
                    <v-text-field
                      :value="discAmt(item)"
                      type="number" min="0" step="0.01"
                      outlined dense hide-details
                      class="exp-input disc-amt"
                      suffix="€"
                      @focus="$event.target.select()"
                      @blur="v => onExpDiscAmtBlur(idx, item, v.target.value)"
                    />
                  </div>
                </td>
                <!-- PDV -->
                <td class="col-tax">
                  <span class="exp-tax-badge" v-if="item.tax && item.tax.rate != null">
                    {{ Math.round(item.tax.rate * 100) }}%
                  </span>
                  <span v-else class="exp-none">—</span>
                </td>
                <!-- Iznos -->
                <td class="col-total exp-total">{{ formatPrice(item.total) }}</td>
                <!-- KPD šifra — obavezno kad je eRačun aktivan -->
                <td v-if="eracunActive" class="col-kpd">
                  <v-text-field
                    :value="item.kpdcode || ''"
                    placeholder="xx.xx.xx"
                    outlined dense hide-details
                    class="exp-input kpd-input"
                    :class="{ 'kpd-missing': eracunActive && (!item.kpdcode || item.kpdcode.trim() === '') }"
                    @input="v => onKpdInput(idx, v)"
                    @focus="$event.target.select()"
                  />
                </td>
                <td class="col-del">
                  <button class="exp-del-btn" @click.stop="$emit('remove-item', idx)" title="Ukloni">
                    <v-icon size="14" color="#E53935">mdi-delete-outline</v-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- Napredne opcije — samo u expanded modu, 2-column grid -->
        <div v-if="showExpandedContent" class="expanded-opts">
          <div class="opts-grid">

            <!-- Fiskaliziraj — samo T/V -->
            <div v-if="paymentMethod === 'T' || paymentMethod === 'V'" class="opt-card">
              <div class="opt-card-label">
                <v-icon size="15" color="#00BCD4" class="mr-2">mdi-cash-register</v-icon>
                Fiskaliziraj
                <v-tooltip v-if="!hasCertificate" bottom max-width="280" color="white" content-class="vpc-tooltip">
                  <template v-slot:activator="{ on }">
                    <span class="eracun-hint-wrap" v-on="on">
                      <span class="opt-hint">· nema certifikata</span>
                      <v-icon size="13" color="#94A3B8" class="ml-1" style="cursor:help;">mdi-help-circle-outline</v-icon>
                    </span>
                  </template>
                  <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;line-height:1.6;">Certifikat za fiskalizaciju nije instaliran. Fiskalizacija nije moguća — račun se može izdati bez fiskalizacije (Ne).</span>
                </v-tooltip>
              </div>
              <div class="opt-seg">
                <button class="opt-pill" :class="{ active: fiscalize }" :disabled="!hasCertificate" @click="$emit('update:fiscalize', true)">Da</button>
                <button class="opt-pill" :class="{ active: !fiscalize }" :disabled="!hasCertificate" @click="$emit('update:fiscalize', false)">Ne</button>
              </div>
            </div>

            <!-- Poziv na broj — samo T/V -->
            <div v-if="paymentMethod === 'T' || paymentMethod === 'V'" class="opt-card">
              <div class="opt-card-label">
                <v-icon size="15" color="#00BCD4" class="mr-2">mdi-pound-box-outline</v-icon>
                Poziv na broj
              </div>
              <div class="opt-seg">
                <button class="opt-pill" :class="{ active: !customPnb }" @click="$emit('update:customPnb', false)">Auto</button>
                <button class="opt-pill" :class="{ active: customPnb }" @click="$emit('update:customPnb', true)">Ručno</button>
              </div>
              <v-text-field v-if="customPnb" :value="paymentReference" @input="$emit('update:paymentReference', $event)" label="Poziv na broj" outlined dense hide-details class="mt-2" placeholder="npr. HR00 1234-567" />
            </div>

            <!-- eRačun — skriveno za MP blagajnu -->
            <div v-if="registerType !== 'MP'" class="opt-card">
              <div class="opt-card-label">
                <v-icon size="15" color="#00BCD4" class="mr-2">mdi-email-outline</v-icon>
                eRačun
                <!-- ALL + nije T: disabled s objašnjenjem -->
                <v-tooltip v-if="registerType === 'ALL' && paymentMethod !== 'T'" bottom max-width="280" color="white" content-class="vpc-tooltip">
                  <template v-slot:activator="{ on }">
                    <span class="eracun-hint-wrap" v-on="on">
                      <span class="opt-hint">· samo za transakcijski</span>
                      <v-icon size="13" color="#94A3B8" class="ml-1" style="cursor:help;">mdi-help-circle-outline</v-icon>
                    </span>
                  </template>
                  <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;line-height:1.6;">eRačun je dostupan samo kada je odabran transakcijski način plaćanja.</span>
                </v-tooltip>
                <v-tooltip v-else-if="!eracunEnabled && eracunDisabledReason" bottom max-width="280" color="white" content-class="vpc-tooltip">
                  <template v-slot:activator="{ on }">
                    <span class="eracun-hint-wrap" v-on="on">
                      <span class="opt-hint">· uvjeti nisu ispunjeni</span>
                      <v-icon size="13" color="#94A3B8" class="ml-1" style="cursor:help;">mdi-help-circle-outline</v-icon>
                    </span>
                  </template>
                  <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;line-height:1.6;">{{ eracunDisabledReason }}</span>
                </v-tooltip>
                <span v-else-if="!eracunEnabled" class="opt-hint">· uvjeti nisu ispunjeni</span>
              </div>
              <v-switch
                :input-value="eracun"
                @change="$emit('update:eracun', $event)"
                :disabled="!eracunEnabled || (registerType === 'ALL' && paymentMethod !== 'T')"
                dense hide-details color="#00BCD4" style="margin:0;"
              />
              <v-text-field
                v-if="eracun && eracunEnabled"
                :value="eracunEmail"
                @input="$emit('update:eracunEmail', $event)"
                label="Email za eRačun"
                outlined dense
                class="mt-2 eracun-email-input"
                placeholder="email@firma.hr"
                prepend-inner-icon="mdi-email-outline"
                :error="eracunEmail.length > 0 && !validEracunEmail"
                :error-messages="eracunEmail.length > 0 && !validEracunEmail ? 'Neispravan format email adrese' : ''"
              />
            </div>

          </div>
        </div>
        </div><!-- /cart-left-inner -->
      </div>

      <!-- DESNO: uvijek vidljivo, uvijek na istom mjestu -->
      <!-- U normalnom modu (shop-cart=250px): prikazuje artikle + kupca + totale + plaćanje -->
      <!-- U expanded modu: prikazuje samo totale + plaćanje (artikli su u cart-left) -->
      <div class="cart-right">

        <!-- Artikli i kupac — skriveni tek nakon kratkog delayt (sprječava blink pri expand animaciji) -->
        <div v-show="showNormalContent" class="cart-rows-container">
        <div class="cart-rows">
          <div v-if="cart.length === 0" class="cart-empty">
            <v-icon size="36" color="#E0E6ED">mdi-cart-outline</v-icon>
            <span>Košarica je prazna</span>
          </div>
          <template v-else>
            <div
              v-for="(item, idx) in cart"
              :key="`right-${item.id}-${idx}`"
              class="c-row"
              @click="$emit('open-item-modal', idx)"
            >
              <span class="c-name">{{ item.name }}</span>
              <span class="c-qty">×{{ item.quantity }}</span>
              <span class="c-price">{{ itemDisplayPrice(item) }}</span>
            </div>
          </template>
        </div>
        <button class="btn-add-writein" @click="$emit('open-write-in')">
          <v-icon size="14" color="#94A3B8" class="mr-1">mdi-plus</v-icon>
          Dodaj stavku na račun
        </button>
        </div><!-- /cart-rows-container -->

        <div class="cart-admin-divider"></div>

        <button class="add-customer-btn" @click="$emit('open-customer-panel')">
          <v-icon size="16" color="#00BCD4">mdi-account-plus-outline</v-icon>
          <span v-if="customer" class="customer-info">
            <span class="customer-name-set">{{ customer.name || customer.oib }}</span>
            <span v-if="customer.oib && customer.name" class="customer-oib-inline">{{ customer.oib || (customer.oibs && customer.oibs[0]) }}</span>
          </span>
          <span v-else>Dodaj kupca · OIB pretraga</span>
        </button>

        <!-- Datumi — klikabilni redovi, otvaraju modal -->
        <div v-if="showDates" class="cart-dates" @click="datesModalOpen = true">
          <div class="cart-date-clickrow">
            <v-icon size="13" color="#00BCD4" class="mr-2">mdi-truck-delivery-outline</v-icon>
            <span class="cart-date-lbl">Datum isporuke</span>
            <span class="cart-date-val">{{ deliveryDateStr }}</span>
          </div>
          <div v-if="showValueDate" class="cart-date-clickrow">
            <v-icon size="13" color="#00BCD4" class="mr-2">mdi-calendar-check-outline</v-icon>
            <span class="cart-date-lbl">Datum valute</span>
            <span class="cart-date-days">{{ selectedPaymentDue }}d</span>
            <span class="cart-date-val">{{ valueDateStr }}</span>
          </div>
        </div>

        <!-- Modal za datume -->
        <shop-dates-modal
          v-if="showDates"
          :open="datesModalOpen"
          :show-value-date="showValueDate"
          :delivery-date="deliveryDate"
          :value-date="valueDate"
          :selected-payment-due="selectedPaymentDue"
          :payment-dues="paymentDues"
          @update:deliveryDate="$emit('update:deliveryDate', $event)"
          @update:valueDate="$emit('update:valueDate', $event)"
          @update:selectedPaymentDue="$emit('update:selectedPaymentDue', $event)"
          @close="datesModalOpen = false"
        />

        <!-- Totali i plaćanje — uvijek vidljivi -->
        <div class="cart-totals">
          <div class="t-row"><span>Međuzbroj</span><span>{{ formatPrice(subtotal) }}</span></div>
          <div class="t-row t-discount" @click="$emit('open-discount-modal')">
            <span><v-icon size="13" color="#e6a817">mdi-tag-outline</v-icon> Popust</span>
            <span>{{ discountDisplay }}</span>
          </div>
          <div class="t-row t-grand">
            <span>UKUPNO</span>
            <span v-if="showVpc">
              {{ formatPrice(vpcTotal) }}<span class="t-grand-mpc"> ({{ formatPrice(grandTotal) }})</span>
            </span>
            <span v-else>{{ formatPrice(grandTotal) }}</span>
          </div>
        </div>

        <div class="pay-zone">
          <!-- Fiskalizacija badge — samo za transakcijski -->
          <v-tooltip v-if="paymentMethod === 'T'" right max-width="260" color="white" content-class="vpc-tooltip">
            <template v-slot:activator="{ on }">
              <div class="fisk-badge" :class="fiscalize ? 'fisk-badge--da' : 'fisk-badge--ne'" v-on="on">
                <span class="fisk-dot" />
                {{ fiscalize ? 'Fiskalizirano' : 'Nefiskalizirano' }}
              </div>
            </template>
            <span style="font-size:12px;color:#1e293b;padding:8px 10px;display:block;line-height:1.6;">
              <strong style="display:block;margin-bottom:3px;">{{ fiscalize ? 'Fiskalizirani račun' : 'Nefiskalizirani račun' }}</strong>
              {{ fiscalize
                ? 'Račun će biti poslan na Poreznu upravu i dobiti JIR/ZKI kod.'
                : 'Račun neće biti poslan na Poreznu upravu te neće imati JIR/ZKI kod.'
              }}
            </span>
          </v-tooltip>
          <div class="pay-row">
            <!-- Lijevo: trenutni način plaćanja → otvara modal i odmah kreira -->
            <button
              class="btn-method"
              :disabled="cart.length === 0 || creatingReceipt"
              @click="$emit('open-payment-modal')"
            >
              <v-icon size="15" class="mr-1" :color="cart.length === 0 ? '#B0BEC5' : '#00BCD4'">{{ currentMethodIcon }}</v-icon>
              <span class="btn-method-label">{{ currentMethodLabel }}</span>
              <v-icon size="14" class="ml-1" :color="cart.length === 0 ? '#B0BEC5' : '#00BCD4'">mdi-chevron-up</v-icon>
            </button>
            <!-- Desno: kreiraj račun s trenutnim methodom odmah -->
            <v-tooltip
              :disabled="!eracunBlockReason"
              bottom max-width="300" color="white" content-class="vpc-tooltip"
            >
              <template v-slot:activator="{ on }">
                <span v-on="on" style="flex:1;display:flex;">
                  <button
                    class="btn-create"
                    :disabled="cart.length === 0 || creatingReceipt || !!eracunBlockReason"
                    style="background-color:#00BCD4 !important;background:#00BCD4 !important;color:#fff !important;border:none !important;width:100%;"
                    @click="$emit('create-receipt')"
                  >
                    <v-progress-circular v-if="creatingReceipt" indeterminate size="14" width="2" color="white" class="mr-1" />
                    {{ creatingReceipt ? '...' : createBtnLabel }}
                  </button>
                </span>
              </template>
              <div style="font-size:12px;color:#1e293b;padding:10px 12px;line-height:1.6;white-space:pre-line;">{{ eracunBlockReason }}</div>
            </v-tooltip>
          </div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'ShopCart',

  props: {
    cart: { type: Array, default: () => [] },
    customer: { type: Object, default: null },
    discount: { type: Object, default: null },
    paymentMethod: { type: String, default: 'G' },
    receiptType: { type: String, default: 'R' },
    currency: { type: String, default: 'EUR' },
    creatingReceipt: { type: Boolean, default: false },
    expanded: { type: Boolean, default: false },
    cartWidth: { type: Number, default: 360 },
    availablePaymentMethods: { type: Array, default: () => [] },
    wholesaleView: { type: Boolean, default: false },
    registerType: { type: String, default: 'MP' },
    eracunActive: { type: Boolean, default: false },
    eracunDisabledReason: { type: String, default: '' },
    eracunBlockReason: { type: String, default: '' },
    fiscalize: { type: Boolean, default: true },
    hasCertificate: { type: Boolean, default: false },
    eracun: { type: Boolean, default: false },
    eracunEmail: { type: String, default: '' },
    eracunEnabled: { type: Boolean, default: false },
    customPnb: { type: Boolean, default: false },
    paymentReference: { type: String, default: '' },
    invoiceDate: { type: Number, default: () => Date.now() },
    deliveryDate: { type: Number, default: () => Date.now() },
    valueDate: { type: Number, default: () => Date.now() },
    selectedPaymentDue: { type: Number, default: 8 },
    paymentDues: { type: Array, default: () => [1, 2, 3, 5, 6, 7, 8, 9, 10, 12, 14, 15, 30, 60, 120] }
  },

  components: {
    ShopDatesModal: () => import('./ShopDatesModal.vue')
  },

  data () {
    return {
      showNormalContent: true,
      datesModalOpen: false,
      taxOptions: [
        { name: 'PDV 25%', rate: 0.25 },
        { name: 'PDV 13%', rate: 0.13 },
        { name: 'PDV 5%', rate: 0.05 },
        { name: 'PDV 0%', rate: 0 },
        { name: '—', rate: null }
      ],
      menuDeliveryExp: false,
      menuValueExp: false,
      showExpandedContent: false,
      _expandTimer: null
    }
  },

  watch: {
    expanded (val) {
      clearTimeout(this._expandTimer)
      if (val) {
        // Expand: ne mijenjaj DOM dok tranzicija ne krene
        this._expandTimer = setTimeout(() => {
          this.showNormalContent = false
          this.showExpandedContent = true
        }, 50)
      } else {
        // Shrink: odmah vrati
        this.showNormalContent = true
        this.showExpandedContent = false
      }
    }
  },

  computed: {
    showWholesaleToggle () { return true },
    createBtnLabel () {
      if (this.paymentMethod === 'P') return 'Izradi ponudu'
      if (this.paymentMethod === 'V') return 'Izradi virman'
      return 'Kreiraj račun'
    },
    validEracunEmail () {
      return /.+@.+\..+/.test(this.eracunEmail)
    },
    showDates () { return true },
    showValueDate () { return ['T', 'V', 'P'].includes(this.paymentMethod) },
    showVpc () { return this.wholesaleView },
    invoiceDateStr () { return this.tsToDisplayDate(this.invoiceDate) },
    deliveryDateStr () { return this.tsToDisplayDate(this.deliveryDate) },
    valueDateStr () { return this.tsToDisplayDate(this.valueDate) },
    currentMethodData () {
      return this.availablePaymentMethods.find(m => m.value === this.paymentMethod) || null
    },
    currentMethodLabel () {
      return this.currentMethodData?.label || 'Plaćanje'
    },
    currentMethodIcon () {
      return this.currentMethodData?.icon || 'mdi-cash-multiple'
    },
    subtotal () {
      // Cijene BEZ popusta (quantity × unitPrice) — ostaje stabilan
      return this.cart.reduce((sum, item) => sum + (item.unitPrice || item.price || 0) * (item.quantity || 1), 0)
    },
    itemsTotal () {
      // Ukupno SA popustom po artiklima
      return this.cart.reduce((sum, item) => sum + (item.total || 0), 0)
    },
    grandTotal () {
      // Primijeni košarični popust na itemsTotal
      if (!this.discount) return this.itemsTotal
      if (this.discount.type === 'RATE') {
        return Math.round(this.itemsTotal * (1 - this.discount.rate / 100))
      }
      if (this.discount.type === 'AMOUNT') {
        return Math.max(0, this.itemsTotal - this.discount.amount)
      }
      return this.itemsTotal
    },
    discountDisplay () {
      const diff = this.subtotal - this.grandTotal
      if (diff <= 0) return '− 0,00 €'
      return '− ' + this.formatPrice(diff)
    },
    vpcTotal () {
      return this.cart.reduce((sum, item) => {
        const mpc = (item.unitPrice || item.price || 0) * (item.quantity || 1)
        const rate = item.tax?.rate ?? 0
        return sum + Math.round(mpc / (1 + rate))
      }, 0)
    }
  },

  methods: {
    onKpdInput (idx, val) {
      // Auto-format xx.xx.xx — samo znamenke
      const digits = (val || '').replace(/\D/g, '').slice(0, 6)
      let formatted = digits
      if (digits.length > 4) formatted = `${digits.slice(0, 2)}.${digits.slice(2, 4)}.${digits.slice(4)}`
      else if (digits.length > 2) formatted = `${digits.slice(0, 2)}.${digits.slice(2)}`
      this.$emit('update-item-kpd', idx, formatted)
    },

    // Prikaz postotka (basis points → %)
    discPct (item) {
      if (!item.discount || item.discount.type !== 'RATE') return (0).toFixed(2)
      const rate = item.discount.rate
      return (rate > 100 ? rate / 100 : rate).toFixed(2)
    },
    // Prikaz apsolutnog iznosa popusta (€)
    discAmt (item) {
      if (!item.discount || item.discount.type !== 'RATE') return (0).toFixed(2)
      const unitPrice = (item.unitPrice || item.price) / 100 // u eurima
      const rate = item.discount.rate
      const pct = rate > 100 ? rate / 100 : rate
      return (unitPrice * pct / 100).toFixed(2)
    },
    // Blur na % polju u expanded tablici
    onExpDiscPctBlur (idx, item, val) {
      const pct = parseFloat(val) || 0
      this.$emit('update-item-field', idx, 'discount',
        pct > 0 ? { type: 'RATE', rate: pct } : null)
    },
    // Blur na € polju — izračunaj % iz iznosa
    onExpDiscAmtBlur (idx, item, val) {
      const amt = parseFloat(val) || 0
      const unitPrice = (item.unitPrice || item.price) / 100 // u eurima
      if (!unitPrice) return
      const pct = parseFloat((amt / unitPrice * 100).toFixed(2))
      this.$emit('update-item-field', idx, 'discount',
        pct > 0 ? { type: 'RATE', rate: pct } : null)
    },

    itemDisplayPrice (item) {
      if (!this.wholesaleView) return this.formatPrice(item.total)
      // VPC total = vpcUnitPrice * quantity
      return this.formatPrice(this.vpcUnitPrice(item) * item.quantity)
    },

    vpcUnitPrice (item) {
      const mpc = item.unitPrice || item.price || 0
      const rate = item.tax?.rate ?? 0
      return Math.round(mpc / (1 + rate))
    },

    tsToDateStr (ts) {
      if (!ts) return ''
      return new Date(ts).toISOString().substr(0, 10)
    },
    tsToDisplayDate (ts) {
      if (!ts) return ''
      const d = new Date(ts)
      const dd = String(d.getDate()).padStart(2, '0')
      const mm = String(d.getMonth() + 1).padStart(2, '0')
      const yyyy = d.getFullYear()
      return `${dd}.${mm}.${yyyy}`
    },
    dateStrToTs (str) {
      return str ? new Date(str).getTime() : Date.now()
    },
    formatPrice (cents) {
      if (!cents && cents !== 0) return '0,00 €'
      return (cents / 100).toFixed(2).replace('.', ',') + ' €'
    }
  },

  beforeDestroy () {
    clearTimeout(this._expandTimer)
  }
}
</script>

<style scoped>
/*
 * LAYOUT STRATEGIJA:
 * cart-right je ABSOLUTNO pozicioniran na desnom rubu shop-carta.
 * Budući da je desni rub shop-carta uvijek na desnom rubu ekrana,
 * cart-right se nikad ne miče na ekranu — neovisno o animaciji shop-carta.
 * cart-left ispunjava preostali prostor (shop-cart.width - 250px).
 * U normalnom modu (shop-cart = 250px) cart-left.width = 0 (skriven).
 */

.shop-cart {
  position: absolute;
  top: 0; bottom: 0; right: 0;
  left: calc(100% - var(--cw, 360px));
  background: #ffffff;
  border-top-left-radius: 12px;
  display: flex;
  flex-direction: column;
  z-index: 2;
  box-shadow: -4px 0 16px rgba(0,0,0,0.06);
  transition: left 0.28s ease, box-shadow 0.28s ease;
  will-change: left;
}
.shop-cart--expanded {
  left: 0;
  box-shadow: none;
  border-left-color: transparent;
}

/* cart-body: relativna pozicija za apsolutno pozicioniranu djecu */
.cart-body {
  flex: 1;
  position: relative;
}

/* cart-left: ispunjava sve osim desnih 250px — pri normalnom modu width=0 */
.cart-left {
  position: absolute;
  top: 0; left: 0; bottom: 0;
  right: var(--cw, 360px);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  border-right: 1px solid rgba(0,0,0,0.06);
}

/* cart-right: uvijek prikačen za desni rub — NIKAD SE NE MIČE */
.cart-right {
  position: absolute;
  top: 0; right: 0; bottom: 0;
  width: var(--cw, 360px);
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  background: #ffffff;
  will-change: transform;  /* GPU layer — sprječava repaint blink */
}

/* Expanded stilovi za stavke */
.shop-cart--expanded .c-name { font-size: 13px; }
.shop-cart--expanded .c-qty { font-size: 12px; }
.shop-cart--expanded .c-price { font-size: 13px; }
.shop-cart--expanded .c-row { padding: 10px 12px; }
.shop-cart--expanded .cart-rows { padding: 8px 16px; }
/* Expanded options */
/* Centriran wrapper za cart-left sadržaj */
.cart-left-inner {
  max-width: 1320px;
  margin: 0 auto;
  width: 95%;
  display: flex;
  flex-direction: column;
  flex: 1;
  overflow: hidden;
}

.expanded-opts {
  border-top: 1px solid rgba(0,0,0,0.05);
  padding: 12px 16px;
  flex-shrink: 0;
}

/* 2-column grid za opcije */
.opts-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 10px;
}
.opt-card {
  background: #F8FAFC;
  border: 1px solid rgba(0,0,0,0.06);
  border-radius: 10px;
  padding: 12px 14px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.opt-card-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #2d3748;
}
.opt-seg { display: flex; gap: 6px; }
.opt-card--dates { grid-column: 1 / -1; }
.dates-grid { display: grid; grid-template-columns: 1fr 1fr; gap: 10px; }
.date-lbl { font-size: 10px; font-weight: 600; color: #94A3B8; text-transform: uppercase; letter-spacing: 0.6px; margin-bottom: 6px; }

/* Period-pill stil za date pickere u expanded */
.exp-date-pill {
  display: inline-flex; align-items: center;
  padding: 6px 12px; border-radius: 20px;
  font-size: 13px; font-weight: 500; color: #6B7280;
  cursor: pointer; border: 1.5px solid #E2E8F0;
  background: #fff; transition: all 0.15s;
  white-space: nowrap; outline: none; width: 100%;
  font-variant-numeric: tabular-nums;
}
.exp-date-pill:hover { border-color: #00BCD4; color: #00838F; background: rgba(0,188,212,0.05); }
.exp-date-due-row { display: flex; gap: 6px; align-items: center; }
.exp-days-combo { max-width: 80px; flex-shrink: 0; }
.exp-days-combo >>> .v-input__slot { border-radius: 20px !important; min-height: 34px !important; font-size: 13px !important; }
.exp-days-combo >>> fieldset { border-color: #E2E8F0 !important; }

/* Datumi u desnom stupcu — klikabilni, isti ton kao add-customer-btn */
.cart-dates {
  margin: 0 8px 6px;
  border: 1.5px dashed #E0E6ED;
  border-radius: 12px;
  padding: 11px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;
  flex-shrink: 0;
}
.cart-dates:hover { border-color: #00BCD4; background: rgba(0,188,212,0.04); }
.cart-date-clickrow {
  display: flex; align-items: center; gap: 6px;
  font-size: 11px;
  min-height: 20px;
}
.cart-date-lbl { color: #94A3B8; font-weight: 600; font-size: 10px; text-transform: uppercase; letter-spacing: 0.4px; flex-shrink: 0; min-width: 80px; }
.cart-date-val { flex: 1; color: #2d3748; font-weight: 600; font-size: 12px; text-align: right; }
.cart-date-days { color: #00BCD4; font-size: 10px; font-weight: 700; }
.opt-row {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 32px;
}
.opt-row--col {
  flex-direction: column;
  align-items: stretch;
}
.opt-row--col .opt-row-left {
  display: flex;
  align-items: center;
  gap: 4px;
}
.opt-row-left {
  flex: 1;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: rgba(70,70,80,0.9);
}
.opt-row-right {
  display: flex;
  gap: 4px;
}
.opt-label {
  font-size: 12px;
  font-weight: 500;
  color: #2d3748;
}
.eracun-hint-wrap { display: inline-flex; align-items: center; cursor: help; }
.eracun-email-input >>> .v-input__slot { border-radius: 8px !important; background: #F8FAFC !important; }
.eracun-email-input >>> fieldset { border-color: #E2E8F0 !important; border-radius: 8px !important; }
.eracun-email-input >>> .v-input__slot:hover fieldset { border-color: #00BCD4 !important; }
.eracun-email-input.v-input--is-focused >>> fieldset { border-color: #00BCD4 !important; border-width: 2px !important; }
.opt-hint {
  font-size: 10px;
  color: #B0BEC5;
  margin-left: 4px;
}
.opt-pill {
  padding: 3px 10px;
  font-size: 11px;
  font-weight: 500;
  border-radius: 20px;
  border: 1.5px solid #E0E6ED;
  background: #fff;
  color: rgba(70,70,80,0.85);
  cursor: pointer;
  transition: all 0.15s;
  line-height: 1.4;
}
.opt-pill:hover:not(:disabled) { border-color: #00BCD4; color: #00BCD4; }
.opt-pill.active { border-color: #00BCD4; background: rgba(0,188,212,0.12); color: #00BCD4; font-weight: 700; }
.opt-pill:disabled { opacity: 0.4; cursor: not-allowed; }
.opt-switch { margin: 0 !important; padding: 0 !important; }
.opt-input { font-size: 12px; }
.cart-hdr {
  height: auto;
  padding: 10px 12px 12px !important;
  background: #F8FAFC;
  border-bottom: 1px solid #e2e8f0 !important;
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
  border-top-left-radius: 12px;
  position: relative;
  z-index: 2;
}
.cart-expand-btn {
  width: 28px; height: 28px; border-radius: 8px;
  background: rgba(0,188,212,0.10); border: 1px solid rgba(0,188,212,0.25);
  color: #00838F; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: background 0.15s;
}
.cart-expand-btn:hover { background: rgba(0,188,212,0.18); }
.cart-title {
  flex: 1; font-size: 12px; font-weight: 800;
  color: #1e293b; text-transform: uppercase; letter-spacing: 0.6px;
  display: flex; align-items: center;
}
.cart-menu-btn {
  width: 28px; height: 28px; border-radius: 8px;
  background: transparent; border: none;
  color: #64748B; font-size: 24px; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  transition: all 0.15s;
}
.cart-menu-btn:hover { background: #F8FAFC; color: rgba(70,70,80,0.9); }
.btn-add-item-hdr {
  margin-right: var(--cw, 360px); /* poravnanje s desnim rubom middle dijela */
  display: flex; align-items: center;
  padding: 5px 10px;
  background: rgba(0,188,212,0.08); border: 1px solid rgba(0,188,212,0.3);
  border-radius: 8px; color: #00BCD4;
  font-size: 11px; font-weight: 700; cursor: pointer;
  transition: all 0.15s; white-space: nowrap;
}
.btn-add-item-hdr:hover { background: rgba(0,188,212,0.16); }
/* ── EXPANDED TABLICA (compact CrudTemplate stil) ── */
.exp-table-wrap {
  flex: 1;
  overflow-y: auto;
  padding: 0 16px;
  scrollbar-width: thin;
  scrollbar-color: rgba(0,188,212,0.4) transparent;
}
.exp-table-wrap::-webkit-scrollbar { width: 5px; }
.exp-table-wrap::-webkit-scrollbar-thumb { background: rgba(0,188,212,0.4); border-radius: 3px; }
.exp-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 13px;
}
.exp-table thead tr {
  border-bottom: 2px solid #EDF2F7;
  position: sticky; top: 0;
  background: #ffffff;
  z-index: 1;
}
.exp-table thead th {
  padding: 10px 8px;
  font-size: 11px; font-weight: 700;
  color: #94A3B8; text-transform: uppercase; letter-spacing: 0.7px;
  white-space: nowrap;
}
.col-num { width: 28px; text-align: center; padding: 8px 4px !important; }
.col-name { text-align: left; min-width: 100px; max-width: 160px; }
.col-qty  { width: 96px; text-align: center; }
.col-price { width: 110px; text-align: right; }
.col-disc { width: 200px; text-align: right; }
.disc-pair { display: flex; gap: 4px; align-items: center; }
.disc-pct { max-width: 88px; }
.disc-amt { max-width: 100px; }
.col-tax  { width: 80px; text-align: center; }
.col-total { width: 90px; text-align: right; }
.col-del  { width: 32px; text-align: center; }
.col-kpd  { width: 100px; text-align: center; }
.kpd-input { font-size: 12px !important; }
.kpd-missing >>> fieldset { border-color: #E53935 !important; }
.exp-row {
  border-bottom: 1px solid #F1F5F9;
  cursor: pointer;
  transition: background 0.1s;
}
.exp-row:hover { background: rgba(0,188,212,0.04); }
.exp-row td { padding: 10px 8px; vertical-align: middle; }
.exp-name { font-size: 13px; font-weight: 700; color: #1e293b; text-transform: capitalize; }
.exp-code { font-size: 10px; color: #94A3B8; margin-top: 2px; }
.exp-qty { font-size: 13px; font-weight: 600; color: #475569; }
.exp-val { font-size: 13px; color: #475569; }
.exp-discount { font-size: 12px; color: #f59e0b; font-weight: 600; }
.exp-none { color: #CBD5E1; }
.exp-total { font-size: 13px; font-weight: 800; color: #00BCD4; }
.exp-del-btn {
  background: transparent; border: none; cursor: pointer;
  display: flex; align-items: center; justify-content: center;
  padding: 4px; border-radius: 4px; opacity: 0.5;
  transition: opacity 0.15s, background 0.15s;
}
.exp-row:hover .exp-del-btn { opacity: 1; }
.exp-del-btn:hover { background: rgba(229,57,53,0.08); }
.exp-input { font-size: 12px !important; }
.exp-input >>> .v-input__slot,
.exp-input >>> .v-input__append-inner { padding: 0 4px !important; }
.exp-input >>> .v-input__slot {
  min-height: 32px !important;
  border-radius: 8px !important;
  background: #F8FAFC !important;
}
.exp-input >>> fieldset { border-color: #E2E8F0 !important; border-radius: 8px !important; }
.exp-input >>> .v-input__slot:hover fieldset { border-color: #00BCD4 !important; }
.exp-input.v-input--is-focused >>> fieldset { border-color: #00BCD4 !important; border-width: 2px !important; }
.exp-input >>> input { font-size: 12px !important; padding: 4px 4px !important; text-align: right; }
.exp-input >>> .v-text-field__suffix { font-size: 11px !important; padding-left: 2px !important; }
.exp-input >>> input[type=number]::-webkit-outer-spin-button,
.exp-input >>> input[type=number]::-webkit-inner-spin-button { -webkit-appearance: none; margin: 0; }
.exp-input >>> input[type=number] { -moz-appearance: textfield; }
.exp-tax-badge {
  display: inline-block;
  font-size: 11px; font-weight: 700;
  color: #64748B;
  background: #F1F5F9;
  border-radius: 6px;
  padding: 3px 7px;
  white-space: nowrap;
}

/* Wrapper s fade-out gradijentom */
.cart-rows-container {
  flex: 1;
  position: relative;
  overflow: hidden;
  min-height: 0;
  display: flex;
  flex-direction: column;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  margin: 8px 8px 0;
}
.cart-rows-container::after {
  content: '';
  position: absolute;
  left: 0; right: 0;
  bottom: 38px; /* visina btn-add-writein */
  height: 32px;
  background: linear-gradient(to bottom, transparent, rgba(255,255,255,0.85));
  pointer-events: none;
  z-index: 1;
}
.cart-rows {
  flex: 1; overflow-y: auto; padding: 4px 4px 4px 8px;
  scrollbar-width: thin; scrollbar-color: rgba(0,188,212,0.5) transparent;
}
.cart-rows::-webkit-scrollbar { width: 5px; }
.cart-rows::-webkit-scrollbar-track { background: transparent; }
.cart-rows::-webkit-scrollbar-thumb { background: rgba(0,188,212,0.5); border-radius: 3px; }
.cart-rows::-webkit-scrollbar-thumb:hover { background: rgba(0,188,212,0.8); }

/* VPC tooltip override */
.vpc-tooltip { background: #ffffff !important; box-shadow: 0 4px 16px rgba(0,0,0,0.10) !important; border: 1.5px solid #00BCD4 !important; border-radius: 10px !important; padding: 0 !important; }

/* VPC badge */
.cart-vpc-badge {
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(0,188,212,0.12);
  color: #00838F;
  font-size: 10px; font-weight: 700;
  height: 18px;
  border-radius: 9px;
  padding: 0 7px;
  margin-left: 6px;
  vertical-align: middle;
  letter-spacing: 0.5px;
  border: 1px solid rgba(0,188,212,0.3);
}

/* Brojač u naslovu — pill badge */
.cart-count {
  display: inline-flex; align-items: center; justify-content: center;
  background: rgba(0,188,212,0.12);
  color: #00BCD4;
  font-size: 11px; font-weight: 700;
  height: 20px;
  border-radius: 10px;
  padding: 0 8px;
  margin-left: 8px;
  vertical-align: middle;
  letter-spacing: 0;
}
.cart-empty {
  display: flex; flex-direction: column; align-items: center;
  gap: 6px; padding-top: 36px;
  font-size: 12px; color: #B0BEC5;
}
.c-row {
  display: flex; align-items: center;
  padding: 12px 6px; border-radius: 6px;
  cursor: pointer; gap: 6px;
  border-bottom: 1px solid #EDF2F7;
  transition: background 0.1s;
}
.c-row:last-child { border-bottom: none; }
.c-row:hover { background: #F7FAFC; }
.btn-add-writein {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 9px 12px;
  background: transparent;
  border: none;
  border-top: 1px dashed #E2E8F0;
  font-size: 12px;
  font-weight: 600;
  color: #94A3B8;
  cursor: pointer;
  transition: color 0.15s, background 0.15s;
  flex-shrink: 0;
}
.btn-add-writein:hover { color: #00BCD4; background: rgba(0,188,212,0.04); }
.c-name { flex: 1; font-size: 13px; color: rgba(70,70,80,0.9); font-weight: 700; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; text-transform: capitalize; }
.c-qty { font-size: 11px; color: #64748B; font-weight: 500; white-space: nowrap; }
.c-price { font-size: 13px; color: #00BCD4; font-weight: 700; white-space: nowrap; }
.t-grand-vpc { font-size: 18px; font-weight: 800; color: #1a202c; letter-spacing: -0.3px; }
.t-grand-mpc { color: #94A3B8; font-weight: 500; margin-left: 4px; }
.exp-vpc-val { font-size: 12px; color: #64748B; font-weight: 600; }
.cart-admin-divider {
  margin: 12px 8px 0;
  border-top: 1px solid #e2e8f0;
}
.add-customer-btn {
  margin: 6px 8px 4px;
  padding: 11px 12px;
  border: 1.5px dashed #E0E6ED;
  border-radius: 12px;
  display: flex; align-items: center; gap: 8px;
  font-size: 11px; color: #475569; cursor: pointer;
  background: transparent;
  transition: all 0.15s;
  width: calc(100% - 16px);
  text-align: left;
}
.add-customer-btn:hover { border-color: #00BCD4; color: #00BCD4; background: rgba(0,188,212,0.04); }
.customer-info { display: flex; flex-direction: column; gap: 1px; flex: 1; text-align: left; }
.customer-name-set { font-weight: 700; color: #2d3748; font-size: 12px; }
.customer-oib-inline { font-size: 10px; font-weight: 600; color: #475569; text-transform: uppercase; letter-spacing: 0.4px; }
.cart-totals { padding: 10px 12px; border-top: 1px solid rgba(0,0,0,0.05); }
.t-row { display: flex; justify-content: space-between; font-size: 12px; color: rgba(70,70,80,0.7); margin-bottom: 5px; }
.t-discount {
  color: #e6a817; cursor: pointer;
  padding: 5px 8px; margin: 0 -8px;
  border-radius: 8px;
  border: 1.5px dashed transparent;
  transition: border-color 0.15s, background 0.15s;
}
.t-discount:hover {
  border-color: #e6a817;
  background: rgba(230,168,23,0.04);
  color: #c78e10;
}
.t-grand {
  font-size: 20px; font-weight: 800; color: #000000;
  margin-top: 10px; padding-top: 10px;
  border-top: 2px solid #EDF2F7;
  letter-spacing: -0.4px;
}
.pay-zone { padding: 10px 8px 10px; border-top: 1px solid rgba(0,0,0,0.05); flex-shrink: 0; display: flex; flex-direction: column; }
.pay-row { display: flex; gap: 6px; align-items: stretch; }

/* Lijevi gumb: odabir načina plaćanja */
.btn-method {
  flex: 1;
  display: flex; align-items: center; justify-content: center; gap: 6px; line-height: 1;
  padding: 14px 6px;
  background: rgba(0,188,212,0.06);
  border: 1.5px solid rgba(0,188,212,0.3);
  border-radius: 10px;
  color: #006f7a;
  font-size: 12px; font-weight: 800;
  cursor: pointer; transition: all 0.15s;
  overflow: hidden;
}
.btn-method:hover:not(:disabled) { border-color: #00BCD4; background: rgba(0,188,212,0.12); }
.btn-method:disabled { opacity: 0.4; cursor: not-allowed; }
.btn-method-label { overflow: hidden; text-overflow: ellipsis; white-space: nowrap; flex: 1; }
.fisk-badge {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.3px;
  margin-bottom: 6px;
  align-self: flex-start;
}
.fisk-badge--da { background: #dcfce7; color: #15803d; }
.fisk-badge--ne { background: #F1F5F9; color: #64748B; }
.fisk-dot {
  width: 6px; height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}
.fisk-badge--da .fisk-dot { background: #16a34a; }
.fisk-badge--ne .fisk-dot { background: #94A3B8; }

/* Desni gumb: kreiraj račun — filled, istaknuti */
.btn-create {
  flex: 1;
  padding: 14px 8px;
  background-color: #00BCD4 !important;
  background: #00BCD4 !important;
  border: none !important;
  color: #ffffff !important;
  border-radius: 10px;
  font-size: 13px; font-weight: 800;
  text-transform: uppercase; letter-spacing: 0.6px;
  cursor: pointer; transition: background-color 0.15s, box-shadow 0.15s;
  display: flex; align-items: center; justify-content: center; gap: 4px;
  box-shadow: 0 2px 6px rgba(0,188,212,0.3);
}
.btn-create:hover:not(:disabled) { background-color: #0097A7 !important; background: #0097A7 !important; }
.btn-create:disabled { opacity: 0.5 !important; cursor: not-allowed; box-shadow: none; }
</style>
